// extracted by mini-css-extract-plugin
var _1 = "TabItem_active__a8b5a";
var _2 = "TabItem_base__a769b";
var _3 = "TabItem_clear__ddeb9";
var _4 = "TabItem_disabled__82a74";
var _5 = "TabItem_grow__3a76b";
var _6 = "TabItem_horizontal__2319a";
var _7 = "TabItem_large__2fb85";
var _8 = "TabItem_medium__5492f";
var _9 = "TabItem_mini__3bdbc";
var _a = "TabItem_root__7da74";
var _b = "TabItem_tabCenter__27238";
var _c = "TabItem_tabLeft__a970d";
var _d = "TabItem_tabRight__62979";
var _e = "TabItem_text__574a1";
export { _1 as "active", _2 as "base", _3 as "clear", _4 as "disabled", _5 as "grow", _6 as "horizontal", _7 as "large", _8 as "medium", _9 as "mini", _a as "root", _b as "tabCenter", _c as "tabLeft", _d as "tabRight", _e as "text" }
